module.exports = __webpack_public_path__ + "img/rightBottom5.3fa5a78.svg";